// Product Slideshow functionality
document.addEventListener('DOMContentLoaded', function() {
  const slideshow = document.querySelector('.product-slideshow');
  if (!slideshow) return;
  
  const slides = slideshow.querySelectorAll('.slide');
  const thumbnails = slideshow.querySelectorAll('.thumbnail');
  const prevBtn = slideshow.querySelector('.slideshow-btn-prev');
  const nextBtn = slideshow.querySelector('.slideshow-btn-next');
  
  let currentSlide = 0;
  
  function showSlide(index) {
    // Hide all slides
    slides.forEach(slide => slide.classList.remove('active'));
    thumbnails.forEach(thumb => thumb.classList.remove('active'));
    
    // Show current slide
    if (slides[index]) {
      slides[index].classList.add('active');
    }
    if (thumbnails[index]) {
      thumbnails[index].classList.add('active');
    }
    
    currentSlide = index;
  }
  
  function nextSlide() {
    const next = (currentSlide + 1) % slides.length;
    showSlide(next);
  }
  
  function prevSlide() {
    const prev = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(prev);
  }
  
  // Event listeners
  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }
  
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }
  
  // Thumbnail clicks
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => showSlide(index));
  });
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    }
  });
  
  // Touch/swipe support for mobile
  let startX = null;
  
  slideshow.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  });
  
  slideshow.addEventListener('touchend', function(e) {
    if (startX === null) return;
    
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;
    
    if (Math.abs(diff) > 50) { // Minimum swipe distance
      if (diff > 0) {
        nextSlide(); // Swipe left -> next
      } else {
        prevSlide(); // Swipe right -> prev
      }
    }
    
    startX = null;
  });
});

// Simple Quantity Selector - Direct DOM manipulation
document.addEventListener('DOMContentLoaded', function() {
  // Prevent multiple initializations
  if (window.quantityHandlerInit) return;
  window.quantityHandlerInit = true;
  
  const decreaseBtn = document.querySelector('[data-qty-action="decrease"]');
  const increaseBtn = document.querySelector('[data-qty-action="increase"]');
  
  if (decreaseBtn && !decreaseBtn.hasAttribute('data-handler-added')) {
    decreaseBtn.setAttribute('data-handler-added', 'true');
    decreaseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const input = this.nextElementSibling;
      if (input && input.name === 'quantity') {
        const currentValue = parseInt(input.value) || 1;
        const newValue = Math.max(currentValue - 1, 1);
        input.value = newValue;
        console.log('Decrease: ' + currentValue + ' -> ' + newValue);
      }
    });
  }
  
  if (increaseBtn && !increaseBtn.hasAttribute('data-handler-added')) {
    increaseBtn.setAttribute('data-handler-added', 'true');
    increaseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const input = this.previousElementSibling;
      if (input && input.name === 'quantity') {
        const currentValue = parseInt(input.value) || 1;
        const newValue = currentValue + 1;
        input.value = newValue;
        console.log('Increase: ' + currentValue + ' -> ' + newValue);
      }
    });
  }
});

// Variant Selector Logic
document.addEventListener('DOMContentLoaded', function() {
  const variantRadios = document.querySelectorAll('.variant-radio-input');
  
  if (variantRadios.length > 0) {
    let productVariants = [];
    
    // Attempt to parse the JSON data embedded in the liquid file
    const jsonScript = document.querySelector('[id^="ProductVariantsJson-"]');
    if (jsonScript) {
      try {
        productVariants = JSON.parse(jsonScript.textContent);
      } catch (e) {
        console.error('Error parsing product variants JSON', e);
      }
    }

    // Function to get currently selected options
    function getSelectedOptions() {
      const fieldsets = Array.from(document.querySelectorAll('.variant-option'));
      return fieldsets.map((fieldset) => {
        const selectedRadio = fieldset.querySelector('input:checked');
        return selectedRadio ? selectedRadio.value : null;
      });
    }

    // Function to find the variant matching the selected options
    function findVariant(selectedOptions) {
      if (productVariants.length === 0) return null;
      return productVariants.find(variant => {
        return variant.options.every((option, index) => {
          return option === selectedOptions[index];
        });
      });
    }

    // Function to update the page state
    function updateProductState() {
      const selectedOptions = getSelectedOptions();
      const variant = findVariant(selectedOptions);
      
      const addToCartBtn = document.querySelector('.add-to-cart-btn');
      const priceContainer = document.querySelector('[data-la-dn-price]');
      const hiddenInput = document.querySelector('input[name="id"]');
      const skuContainer = document.querySelector('.product-sku');
      
      if (variant) {
        // Update hidden input ID (Critical for "Add to Cart")
        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.setAttribute('data-productid', variant.product_id || document.querySelector('[data-productid]')?.dataset.productid);
        }

        // Update URL
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', newUrl);

        // Update Price
        if (priceContainer) {
           const currentPriceEl = priceContainer.querySelector('.price-current');
           if (currentPriceEl) {
             const currencySymbol = currentPriceEl.innerText.replace(/[0-9.,]/g, '').trim()[0] || '$';
             currentPriceEl.innerText = currencySymbol + (variant.price / 100).toFixed(2);
           }
           
           // Update price-in-button
           const btnPrice = document.querySelector('.price-in-button');
           if (btnPrice) {
              const currencySymbol = btnPrice.innerText.replace(/[0-9.,]/g, '').trim()[0] || '$';
              btnPrice.innerText = currencySymbol + (variant.price / 100).toFixed(2);
           }
        }

        // Update SKU
        if (skuContainer && variant.sku) {
           skuContainer.innerText = 'SKU: ' + variant.sku;
        }

        // Update Add to Cart Button
        if (addToCartBtn) {
          if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('btn-secondary');
            addToCartBtn.classList.add('btn-primary');
            
            const btnText = addToCartBtn.querySelector('span:not(.separator-dot):not(.price-in-button)');
            const availableText =
              addToCartBtn.dataset.isPreOrder === 'true'
                ? addToCartBtn.dataset.preOrderText
                : addToCartBtn.dataset.addToCartText;
            if (btnText && availableText) btnText.textContent = availableText;
            
            // Re-show price in button if hidden
            const btnPrice = addToCartBtn.querySelector('.price-in-button');
             const separator = addToCartBtn.querySelector('.separator-dot');
            if (btnPrice) btnPrice.style.display = 'inline';
             if (separator) separator.style.display = 'inline';
            
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.remove('btn-primary');
            addToCartBtn.classList.add('btn-secondary');
            
            const btnText = addToCartBtn.querySelector('span:not(.separator-dot):not(.price-in-button)');
            const soldOutText = addToCartBtn.dataset.soldOutText;
            if (btnText && soldOutText) btnText.textContent = soldOutText;
            
             // Hide price in button for Sold Out
             const btnPrice = addToCartBtn.querySelector('.price-in-button');
             const separator = addToCartBtn.querySelector('.separator-dot');
             if (btnPrice) btnPrice.style.display = 'none';
             if (separator) separator.style.display = 'none';
          }
        }

      } else (
        // Variant does not exist or unavailable combination
        console.log('Variant not found')
      );
    }

    // Attach Event Listeners
    variantRadios.forEach(radio => {
      radio.addEventListener('change', updateProductState);
    });
    
    // Check for "variant" query param on load to pre-select
    const params = new URLSearchParams(window.location.search);
    const initialVariantId = params.get('variant');
    if (initialVariantId && productVariants.length > 0) {
       const variant = productVariants.find(v => v.id == initialVariantId);
       if(variant) {
           variant.options.forEach((optValue, index) => {
               const radio = document.querySelector(`.variant-radio-input[data-option-position="${index+1}"][value="${CSS.escape(optValue)}"]`);
               if(radio) radio.checked = true;
           });
           updateProductState();
       }
    }
  }
});